var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marketing-campaign-tabs',{attrs:{"active-tab-name":_vm.activeTabName,"tab-options":_vm.$options.marketingCampaignsTabs},on:{"select-tab":_vm.selectTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }